import { Component } from '@angular/core';

@Component({
  selector: 'app-search-branch',
  templateUrl: './search-branch.component.html',
  styleUrls: ['./search-branch.component.scss']
})
export class SearchBranchComponent {

}
